import {
  Wrapper,
  Text,
  Counter
} from './Styles'

interface props {
  count?: number | string;
  children: React.ReactElement | string;
}

export default function PageTitle({ count, children }: props) {
  return (
    <Wrapper>
      <Text>{children}</Text>
      {count && <Counter>{count}</Counter>}
    </Wrapper>
  )
}